// src/pages/JudoCoachPro/components/JudoCoachProAudienceBar.jsx

import React from "react";

import Reveal from "../../../components/ui/Reveal";
import { JUDO_COACH_AUDIENCES } from "../data/judoCoachProData";

export default function JudoCoachProAudienceBar() {
  return (
    <section className="bg-white dark:bg-slate-950">
      <div className="mx-auto max-w-[1480px] px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="grid border-b border-slate-200 dark:border-white/10 md:grid-cols-3">
            {JUDO_COACH_AUDIENCES.map((audience, index) => {
              const Icon = audience.icon;

              return (
                <article
                  key={audience.title}
                  className={[
                    "py-8 md:px-8 lg:py-10",
                    index > 0
                      ? "border-t border-slate-200 dark:border-white/10 md:border-l md:border-t-0"
                      : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  <div className="flex items-start gap-4">
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-blue-50 text-[#0868f2] dark:bg-blue-500/10 dark:text-blue-300">
                      <Icon />
                    </span>

                    <div>
                      <h2 className="text-lg font-semibold tracking-tight text-slate-950 dark:text-white">
                        {audience.title}
                      </h2>

                      <p className="mt-2 text-sm leading-7 text-slate-500 dark:text-slate-400">
                        {audience.text}
                      </p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}